export default () => {
  if (process.env.API_MODE === 'mock') {
    const { worker } = require('../mocks/browser')
    worker.start()
    console.log('worker started')
  }
}
